import { createAsyncThunk } from '@reduxjs/toolkit';

import { ReviewData } from './consultationsReviews.reducer';
import { createNewConsultationReview, getRatedConsultationsReviews } from '../../api/consultation';
import { IPromotionalCode } from '../../pages/types';

type ReviewResponse = {
  review: Omit<ReviewData, 'currentSpecialist'>;
  promo_code: IPromotionalCode | null;
};

type CreateReview = Omit<ReviewData, 'currentSpecialist'> & {
  promo_code_percent_off?: number;
};

export const createConsultationReview = createAsyncThunk<ReviewResponse, CreateReview>(
  'consultationsReviews/createConsultationReview',
  async (payload, thunkAPI) => {
    const data = await createNewConsultationReview(payload);
    return thunkAPI.fulfillWithValue(data);
  }
);

export const fetchRatedConsultations = createAsyncThunk<Omit<ReviewData, 'currentSpecialist'>[], string>(
  'consultationsReviews/getRatedConsultations',
  async (userId, thunkAPI) => {
    const data = await getRatedConsultationsReviews(userId);
    return thunkAPI.fulfillWithValue(data);
  }
);
